import { ca } from '@cian/analytics';
export function trackSocialCreateCreateClick(label) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'complete_reg_popup_click',
    label: label
  });
}
export function trackSocialCreateShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'complete_reg_popup_show'
  });
}
export function trackSocialButtonClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'click',
    label: type
  });
}
export function trackSocialAuthenticateEmailTaken() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'link_accounts_show'
  });
}
export function trackSocialMergeMergeClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'link_accounts_click'
  });
}
export function trackSocialMergeSucceed() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'link_accounts_success'
  });
}